interface FormErrorProps {
  message: string;
  id?: string;
}

export const FormError: React.FC<FormErrorProps> = ({ message, id }) => {
  if (!message) return null;

  return (
    <p id={id} className="text-sm text-red-500">
      {message}
    </p>
  );
};